import React, { useState } from 'react';
import { Button } from './ui/button.jsx';
import { Input } from './ui/input.jsx';
import { Label } from './ui/label.jsx';

const TestingGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem('testing_access') === 'granted'
  );
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Check credentials
    if (email === 'chris@dcsbuilt.com.au' && password === 'redcar01') {
      sessionStorage.setItem('testing_access', 'granted');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid credentials. Please check your email and password.');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-5">
          {/* Logo + Blurb side by side */}
          <div className="flex items-center gap-4 mb-3">
            <img 
              src="/learning-smart-logo.png" 
              alt="Learning Smart Logo" 
              className="h-24 w-auto object-contain flex-shrink-0"
            />
            <div>
              <h1 className="text-xl font-bold text-gray-800">
                Learning Smart
              </h1>
              <p className="text-sm font-semibold text-purple-600 italic mb-1">
                "Discover, Dream, Learn"
              </p>
              <p className="text-xs text-gray-600 leading-relaxed">
                Empowering young minds through engaging children's books that inspire curiosity, creativity, and a lifelong love of learning.
              </p>
            </div>
          </div>

          {/* Notice */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
            <p className="text-xs text-blue-800 text-center">
              <strong>Site Coming Soon!</strong>
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-2">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="mt-1"
              />
            </div>

            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                className="mt-1"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-sm text-red-700 text-center">{error}</p>
              </div>
            )}

            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
              size="lg"
            >
              Access Site
            </Button>
          </form>

          {/* Footer */}
          <div className="mt-3 pt-3 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              Limited Access
            </p>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-6 text-center">
          <p className="text-white text-sm">
            Launching soon with amazing stories for children.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestingGate;
